import './styles/ios-100vh-fix';
import build from '@/meta/build';
import { loadConfig } from './config';
import { registerApplication, start } from 'single-spa';
import { SHELL_APP } from "@/config/app-name";

// Due to an issue with Firefox that sporadically read document.currentScript as null when inside a callback or event
// we make the document.currentScript a global window variable and use this inside asynchronous bootloader.ts instead.
// https://github.com/webpack/webpack/issues/10510
// https://stackoverflow.com/questions/38769103/document-currentscript-is-null
window.documentCurrentScriptSrc = (document.currentScript as HTMLScriptElement).src;

// env-config is pre-loaded
loadConfig()
  .then(() => {
    if (build.isUnderMaintenance) {
      import(/* webpackChunkName: "bootloader-maintenance" */ './bootloader-maintenance');
    } else {
      // IMPORTANT! need to load the bootstrapper async, this allows us to
      // share our federated module dependencies in a non-eager way.

      // register shell as a single-spa application
      registerApplication(
        SHELL_APP,
        () => import(/* webpackChunkName: "bootloader" */ './bootloader'),
        () => true, // always active
      );

      start();
    }
  })
  .catch((err) => console.log(err));

// make typescript look at this file as a module (ref isolatedModules option).
export {};
